import { pslClient } from "@/common/http-common";
import { getPostUrlByQuoteAccess } from "@/common/utils";
import {
  API_URL_CONFIRM_ELIGIBILITY,
  API_URL_CREATE_LEAD_QUOTE_MULTIPLE_PROPERTY,
  API_URL_CREATE_ONLINE_QUOTE,
  API_URL_RETRIEVE_D2C_QUOTE_BY_QUOTEACCESS,
  API_URL_RETRIEVE_D2C_QUOTE_BY_REF,
  API_URL_SYNC_QUOTE_REQUEST,
  API_URL_UPDATE_SELECTED_QUOTE,
} from "@/constants/api.constants";
import {
  API_URL_EMAIL,
  API_URL_POST_QUOTE,
  API_URL_RETRIEVE_QUOTE,
  API_URL_SAVE_RESULT_STAGE,
  API_URL_SHARE_QUOTE_OR_RESULTS,
  API_URL_UPDATE_QUOTE,
} from "@/constants/api.constants.js";
import { CALL_CHANNEL, PRODUCT } from "@/constants/common.constants";

class QuoteService {
  createQuote(data, config) {
    // Start a new partial (INPROGRESS) quote
    return pslClient.post(API_URL_POST_QUOTE, data, config).then((res) => {
      return res.data;
    });
  }
  /**
   * Create online quote
   */
  async createOnlineQuote(data, productId) {
    // Start a new partial (INPROGRESS) quote
    return pslClient
      .post(
        API_URL_CREATE_ONLINE_QUOTE,
        {
          CallChannelType: CALL_CHANNEL.referralSelfServe,
          BranchNumber: "",
          ProductId: productId || PRODUCT.Home,
          IsPartialQuote: true,
          Answers: data,
        },
        { withCredentials: true }
      )
      .then((res) => {
        return res.data;
      });
  }
  updateQuote(quoteRequestId, data, config) {
    // Save a partial (INPROGRESS) quote during Step 1/2
    const url = getPostUrlByQuoteAccess(
      `${API_URL_UPDATE_QUOTE}/${quoteRequestId}`,
      config
    );
    return pslClient.post(url, data, config).then((res) => {
      return res.data;
    });
  }
  saveQuoteResults(quoteRequestId, data, config) {
    // Save during Step 3 - just update the UserRef and/or CommSac
    const url = getPostUrlByQuoteAccess(
      `${API_URL_SAVE_RESULT_STAGE}/${quoteRequestId}`,
      config
    );
    return pslClient.post(url, data, config).then((res) => {
      return res.data;
    });
  }
  shareQuote(quoteId, payload, config) {
    const url = `${API_URL_SHARE_QUOTE_OR_RESULTS}/${quoteId}/${API_URL_EMAIL}`;
    return pslClient.post(url, payload, config);
  }
  shareResults(quoteRequestId, payload, config) {
    const url = `${API_URL_SHARE_QUOTE_OR_RESULTS}/${quoteRequestId}/${API_URL_EMAIL}`;
    return pslClient.post(url, payload, config);
  }
  retrieveQuote(quoteRequestId, config) {
    const url = `${API_URL_RETRIEVE_QUOTE}/${quoteRequestId}`;
    return pslClient.get(url, config).then((res) => {
      return res.data;
    });
  }
  retrieveQuoteByAccessId(quoteAccessId, config) {
    const url = `${API_URL_RETRIEVE_D2C_QUOTE_BY_QUOTEACCESS}/${quoteAccessId}`;
    return pslClient
      .get(url, { ...config, withCredentials: true })
      .then((res) => {
        return res.data;
      });
  }
  /**
   * check if quote match with information(for D2C quote)
   * @param {string} quoteReference
   * @param {string} postCode
   * @param {string} dateOfBirth date formatted as dd/MM/yyyy
   * @returns {Promise<{ContinuationUrl: string, QuoteRequestId: number}>} with value of continuation url
   */
  async retrieveQuoteByQuoteReference(
    quoteReference,
    postCode,
    dateOfBirth,
    pageProductId
  ) {
    const pageProductIdsString = pageProductId.reduce(
      (acc, current) => (acc += `&pageProductId=${current}`),
      ""
    );

    const url = `${API_URL_RETRIEVE_D2C_QUOTE_BY_REF}?quoteReference=${quoteReference}&postCode=${postCode}&dateOfBirth=${dateOfBirth}${pageProductIdsString}`;
    const { data } = await pslClient.get(url, { withCredentials: true });
    return data;
  }

  async confirmEligibility(request) {
    return pslClient
      .post(API_URL_CONFIRM_ELIGIBILITY, request, {
        withCredentials: true,
      })
      .then((res) => res.data);
  }

  async updateSelectedQuote(data, config) {
    const url = `${API_URL_UPDATE_SELECTED_QUOTE}`;
    return pslClient.put(url, data, config);
  }

  async syncQuoteRequest(data, config) {
    const url = `${API_URL_SYNC_QUOTE_REQUEST}`;
    return pslClient.put(url, data, config);
  }

  async createLeadAndLeadQuoteForMultiplePropertyLead(quoteRequestId, config) {
    const url = `${API_URL_CREATE_LEAD_QUOTE_MULTIPLE_PROPERTY}/${quoteRequestId}`;
    return pslClient.post(url, null, config);
  }
}

export default new QuoteService();
